import React from 'react'
import { MdBookmark, MdBookmarkBorder } from 'react-icons/md'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Text from '../Text/Text'
import Flex from '../Flex/Flex'
import ChatBig from '../Icons/ChatBig'
import ProcessBig from '../Icons/ProcessBig'
import MegaphoneBig from '../Icons/MegaphoneBig'
import BoxBig from '../Icons/BoxBig'
import ComissionBig from '../Icons/ComissionBig'
import PricingProcessBig from '../Icons/PricingProcessBig'
import TrainingBig from '../Icons/TrainingBig'
import WorkToolBig from '../Icons/WorkToolBig'
import styles from './cardHighlight.module.scss'

const VARIATIONS = [1, 2, 3, 4]

const CardHighlight = (props) => {
  const {
    title,
    typeText,
    sizeTitle,
    variation,
    isMarked,
    onPressMarker,
    onClick,
    className,
    classNameTitle
  } = props

  const renderIlustration = (categoryId) => {
    switch (categoryId) {
      case 1:
        // campanhas
        return <MegaphoneBig />
      case 2:
        // comunicados
        return <ChatBig />
      case 4:
        // Produtos
        return <BoxBig />
      case 5:
        // comissionamento
        return <ComissionBig />
      case 6:
        // Ferramentas
        return <WorkToolBig />
      case 7:
        // Precificacao
        return <PricingProcessBig />
      case 8:
        // Treinamento
        return <TrainingBig />
      default:
        // Processos 3
        return <ProcessBig />
    }
  }

  const selectVariation = (categoryId) => {
    switch (categoryId) {
      case 2:
      case 5:
        return 'secondary'
      case 3:
      case 7:
        return 'quaternary'
      case 4:
      case 6:
        return 'primaryLight'
      default:
        return 'tertiary'
    }
  }

  const containerClass = classNames(styles.container, className, {
    [styles[selectVariation(variation)]]: selectVariation(variation)
  })

  return (
    <div className={containerClass} onClick={onClick}>
      <Flex alignItems="flex-start" justifyContent="space-between">
        <div onClick={onClick} className={classNameTitle}>
          <Text color="white" size={sizeTitle} bold width="100%">
            {title}
          </Text>
        </div>
        {onPressMarker && (
          <button
            type="button"
            style={{
              background: 'none',
              border: 0,
              outline: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onClick={onPressMarker}
          >
            {isMarked && <MdBookmark color="white" size={30} />}
            {!isMarked && <MdBookmarkBorder color="white" size={30} />}
          </button>
        )}
      </Flex>
      {typeText && (
        <Flex alignItems="flex-end" justifyContent="space-between">
          <div onClick={onClick} className={styles.typeContainer}>
            <Text font="custom" size="xxs" color="white">
              {typeText}
            </Text>
          </div>
        </Flex>
      )}
      <div onClick={onClick} className={styles.ilustration}>
        {renderIlustration(variation)}
      </div>
    </div>
  )
}

CardHighlight.defaultProps = {
  variation: 1,
  typeText: null,
  sizeTitle: 'xs',
  isMarked: false,
  onPressMarker: null,
  onClick: null,
  className: null,
  classNameTitle: null
}

CardHighlight.propTypes = {
  variation: PropTypes.oneOf(VARIATIONS),
  title: PropTypes.string.isRequired,
  typeText: PropTypes.string,
  sizeTitle: PropTypes.string,
  isMarked: PropTypes.bool,
  onPressMarker: PropTypes.func,
  onClick: PropTypes.func,
  className: PropTypes.string,
  classNameTitle: PropTypes.string
}

export default CardHighlight
